/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { _object } from 'utils/interfaces'

import { InputField } from '../form-inputs'
import { sliderService } from 'services/slider.service'
import { toast } from 'react-toastify'
import store from 'store'
import { DeleteIcon } from 'assets/svg'
import { mediaService } from 'services'

const SliderEditModal = (props: _object) => {
	// })
	const [loading, setLoading] = useState(false)
	const [slider, setSlider] = useState<_object>({})
	const [selectedFile, setSelectedFile] = useState<File | null>(null)
	const [isUploading, setIsUploading] = useState(false)

	const sliderDetail = () => {
		sliderService.getSliderDetails(props?.id).then((results: _object) => {
			setSlider(results)
		})
	}
	useEffect(() => {
		sliderDetail()
	}, [props?.id])

	const validationSchema = Yup.object({
		title: Yup.string().label('Title').required()
	})
	const formik: _object = useFormik({
		initialValues: {
			title: slider?.title || '',
			target_link: slider?.target_link || '',
			status: slider?.status || ''
		},
		validationSchema,
		enableReinitialize: true,
		onSubmit: async (values) => {
			setLoading(true)

			sliderService.updateSlider(props.id, values).then((results: _object) => {
				if (results.error === false) {
					setLoading(false)
					sliderDetail()
					window.location.reload()
				}
			})
		}
	})

	const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files ? e.target.files[0] : null
		if (file) {
			setSelectedFile(file)
		}
	}
	useEffect(() => {
		if (!selectedFile) return
		setIsUploading(true)

		const uploadImage = async () => {
			const data = new FormData()
			if (props.id) {
				data.append('entity_id', props.id)
			}
			data.append('entity_type', 'slider')
			data.append('key', 'slider_image')
			data.append('files', selectedFile)
			const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

			const response = await fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					Authorization: accessToken ? accessToken : ''
				},
				body: data
			})

			const result = await response.json()
			if (result.error === false) {
				// toast.success(result.message || 'Image uploaded successfully.', {
				//   autoClose: 3000
				// })
				sliderDetail()
			} else if (result.error === true) {
				toast.error(result.message || 'Image not uploaded.', {
					autoClose: 3000
				})
			}
			setIsUploading(false)
		}

		uploadImage()
	}, [selectedFile])

	const deleteSlide = (id: string) => {
		if (window.confirm('Are you sure you want to delete this slide?')) {
			mediaService.deleteMediaData(id).then((results: _object) => {
				if (results?.error === false) {
					sliderDetail()
				}
			})
		}
	}

	return (
		<>
			<div
				id={`slider-modal${props?.id}`}
				tabIndex={-1}
				aria-hidden="true"
				className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
			>


				{/* Modal Content */}
				<div className="relative z-10 max-h-full w-full max-w-2xl rounded-lg border border-gray-200 bg-white shadow-sm">
					<div className="flex items-center justify-between rounded-t border-b border-gray-200 p-4">
						<h3 className="text-lg font-semibold">Edit slide</h3>
						<button
							type="button"
							className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
							data-modal-hide={`slider-modal${props?.id}`}
						>
							<svg
								className="h-3 w-3"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 14 14"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
								/>
							</svg>
							<span className="sr-only">Close modal</span>
						</button>
					</div>

					<form onSubmit={formik.handleSubmit} className='p-4'>
						<div className="grid grid-cols-1">
							<div>
								<div className="mb-4">
									<InputField
										label="Title"
										type="text"
										id="title"
										name="title"
										value={formik.values.title}
										onChange={formik.handleChange}
										className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
										placeholder="Title"
										required={true}
									/>
								</div>
								<div className="mb-4">
									<InputField
										label="Target Link"
										type="text"
										id="target_link"
										name="target_link"
										value={formik.values.target_link}
										onChange={formik.handleChange}
										className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
										placeholder="Target Link"
										required={true}
									/>
								</div>

								<div className="mb-5">
									<label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
										Status <span className="text-red-500">*</span>
									</label>
									<div className="flex gap-6">
										<label className="flex items-center gap-2 text-sm text-gray-700">
											<input
												type="radio"
												name="status"
												value="active"
												checked={formik.values.status === 'active'}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												required
											/>
											Active
										</label>

										<label className="flex items-center gap-2 text-sm text-gray-700">
											<input
												type="radio"
												name="status"
												value="inactive"
												checked={formik.values.status === 'inactive'}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												required
											/>
											Inactive
										</label>
									</div>
								</div>

								<div className="mb-4">
									{slider?.media?.length > 0 ? (
										<div className="relative inline-block h-[120px] w-[120px]">
											<img
												src={slider?.media[0]?.path}
												alt={slider.title}
												className="h-full w-full rounded-md object-cover"
											/>
											<button
												type="button"
												onClick={() => deleteSlide(slider.media[0].id)}
												title="Delete Slide"
												className="absolute top-1 right-1 rounded-full bg-white p-1 shadow-sm hover:bg-gray-100"
											>
												<DeleteIcon className="h-[20px] w-[20px] text-red-500" />
											</button>
										</div>
									) : (
										<>
											<label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
												Slide Image <span className="text-red-500">*</span>
											</label>
											<h3 className="mb-2 text-sm text-gray-700">1904W × 1072H | 16:9</h3>
											<label htmlFor="imageUpload">
												<div className="relative flex h-32 w-32 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">                          <input
													type="file"
													id="imageUpload"
													accept=".png, .jpg, .jpeg"
													onChange={(e) => handleImageChange(e)}
													className="absolute inset-0 z-10 cursor-pointer opacity-0"
												/>
													{isUploading ? (
														<svg
															className="h-8 w-8 animate-spin text-purple-900"
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
														>
															<circle
																className="opacity-25"
																cx="12"
																cy="12"
																r="10"
																stroke="currentColor"
																strokeWidth="4"
															></circle>
															<path
																className="opacity-75"
																fill="currentColor"
																d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
															></path>
														</svg>
													) : (
														<span className="text-4xl font-bold text-purple-900">+</span>
													)}
												</div>
											</label>
										</>
									)}
								</div>

								<button
									type="submit"
									className={`rounded bg-purple-900 hover:bg-purple-950 font-medium px-4 py-2 text-white text-sm ${loading == true && 'opacity-50 hover:bg-purple-950 is-loading'}`}
								>
									{location.pathname.endsWith('/add') ? 'Add Deal' : 'Save Changes'}
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
		// </div
		// <div
		//   id={`slider-modal${props?.id}`}
		//   tabIndex={-1}
		//   aria-hidden="true"
		//   className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
		// >
		//   <div className="fixed inset-0 bg-black/50"></div>

		//   {/* Modal Content */}
		//   <div className="relative z-10 max-h-full w-full max-w-2xl rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
		//     <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-3 px-5">
		//       <h3 className="text-lg font-semibold">Edit slide</h3>
		//       <button
		//         type="button"
		//         className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
		//         data-modal-hide={`slider-modal${props?.id}`}
		//       >
		//         <svg
		//           className="h-3 w-3"
		//           aria-hidden="true"
		//           xmlns="http://www.w3.org/2000/svg"
		//           fill="none"
		//           viewBox="0 0 14 14"
		//         >
		//           <path
		//             stroke="currentColor"
		//             strokeLinecap="round"
		//             strokeLinejoin="round"
		//             strokeWidth="2"
		//             d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
		//           />
		//         </svg>
		//         <span className="sr-only">Close modal</span>
		//       </button>
		//     </div>{' '}
		//     <div className="mb-6">
		//       <h1 className="mb-1 text-2xl font-semibold">
		//         {/* {product?.title} <small className="block">SKU: {product?.sku}</small> */}
		//       </h1>
		//     </div>
		//     <div className="grid grid-cols-2">
		//       <div className="flex flex-col gap-4">
		//         <form onSubmit={formik.handleSubmit}>
		//           <div className="mb-4">
		//             <InputField
		//               label="Title"
		//               name="title"
		//               type="text"
		//               placeholder="Title"
		//               onChange={formik.handleChange}
		//               value={formik.values.title}
		//               onBlur={formik.handleBlur}
		//               error={formik.touched.title && formik.errors.title}
		//               required
		//             />
		//           </div>

		//           <div className="mb-4">
		//             <InputField
		//               label="Target Link"
		//               name="target_link"
		//               type="text"
		//               placeholder="https://example.com"
		//               onChange={formik.handleChange}
		//               value={formik.values.target_link}
		//               onBlur={formik.handleBlur}
		//               error={formik.touched.target_link && formik.errors.target_link}
		//             />
		//           </div>
		//           <div className="mb-4">
		//             <p>Status</p>
		//             {[
		//               {key: 'Active', value: 'active' },
		//               {key: 'Inactive', value: 'inactive' }
		//             ].map((item, i) => (
		//               <label key={i} className="flex items-center gap-2 text-sm text-gray-700">
		//                 <input
		//                   type="radio"
		//                   name="status"
		//                   id={`status-${item.value}`}
		//                   value={item.value}
		//                   checked={formik.values.status === item.value}
		//                   onChange={formik.handleChange}
		//                   onBlur={formik.handleBlur}
		//                   className="text-purple-600 focus:ring-purple-500"
		//                 />
		//                 {item.key}
		//               </label>
		//             ))}
		//           </div>

		//           <div className="p-5">
		//             <h3 className="mb-2 text-sm text-gray-700">Slide Image</h3>
		//             <h3 className="mb-2 text-sm text-gray-700">W-400px & H-200px</h3>
		//             <h3 className="mb-2 text-sm text-gray-700">Aspect Ratio 2:1</h3>
		//             <div className="flex flex-wrap gap-4">
		//               {slider?.media?.map((item: _object, i: number) => (
		//                 <div key={i} className="relative h-32 w-32 overflow-hidden rounded-md border">
		//                   <img
		//                     src={item?.path}
		//                     alt={item?.title || 'Slide image'}
		//                     className="h-full w-full object-cover"
		//                   />
		//                   <button
		//                     type="button"
		//                     onClick={() => deleteSlide(item.id)}
		//                     title="Delete Slide"
		//                     className="absolute top-1 right-1 rounded-full bg-white p-1 shadow-sm hover:bg-gray-100"
		//                   >
		//                     <DeleteIcon className="h-[20px] w-[20px] text-red-500" />
		//                   </button>
		//                 </div>
		//               ))}
		//               <label htmlFor="imageUpload" className="block w-fit">
		//                 <div className="flex h-32 w-32 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
		//                   <input
		//                     type="file"
		//                     id="imageUpload"
		//                     accept=".png, .jpg, .jpeg"
		//                     onChange={(e) => handleImageChange(e)}
		//                     className="hidden"
		//                   />
		//                   {isUploading ? (
		//                     <svg
		//                       className="h-8 w-8 animate-spin text-purple-900"
		//                       xmlns="http://www.w3.org/2000/svg"
		//                       fill="none"
		//                       viewBox="0 0 24 24"
		//                     >
		//                       <circle
		//                         className="opacity-25"
		//                         cx="12"
		//                         cy="12"
		//                         r="10"
		//                         stroke="currentColor"
		//                         strokeWidth="4"
		//                       ></circle>
		//                       <path
		//                         className="opacity-75"
		//                         fill="currentColor"
		//                         d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
		//                       ></path>
		//                     </svg>
		//                   ) : (
		//                     <span className="text-4xl font-bold text-purple-900">+</span>
		//                   )}
		//                 </div>
		//               </label>
		//               <Button
		//                 label=" Save Changes"
		//                 type="submit"
		//                 className="rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
		//                 loading={loading}
		//                 disabled={!formik.isValid || !formik.dirty}
		//               />
		//             </div>
		//           </div>
		//         </form>
		//       </div>
		//     </div>
		//   </div>
		// </div>
	)
}

export default SliderEditModal
